import { SupportLogRequest, SupportReportRequest } from './types';

// A 404 (Production before the Support routes exist, a company without the
// Support link, an older Ops) must never send POS to the Not Found page
// (api/instance.ts): the receipt strip is on every receipt. Same origin on
// Dev and Production, so the header needs no CORS preflight.
export const NOT_FOUND_OK = { 'allow-not-found': 'true' };

const get = (url: string) => ({ url, method: 'get', headers: NOT_FOUND_OK });

// Every Customer care read (Ops, /api/v1/support/pos). Plain functions so the
// tests can send them through the real axios interceptor.
export const supportRequests = {
  settings: () => get('support/pos/settings'),
  receiptSupport: (checkoutId: number) =>
    get(`support/pos/receipts/${checkoutId}`),
  careReceipt: (checkoutId: number) =>
    get(`support/pos/receipts/${checkoutId}/detail`),
  supportReport: ({ to, from }: SupportReportRequest) =>
    get(`support/pos/report?from=${from}&to=${to}`),
  supportLog: ({ status, before }: SupportLogRequest) => {
    const params = new URLSearchParams();
    if (status) {
      params.set('status', status);
    }
    if (before) {
      params.set('before', String(before));
    }
    const search = params.toString();
    return get(`support/pos/requests${search ? `?${search}` : ''}`);
  },
};

// The refunds log and the report answer 404 while this company has no Support
// link (owner's phone, 31 Oct: "Couldn't load the Support refunds."):
// - Production before G3: no CloudFront route, so Main answers with Fastify's
//   own "Route GET:… not found";
// - Ops without the bridge config, or another company: the bridge's not_found.
// Any other 404 (or failure) is a real error and still shows "Couldn't load".
export const isNotLinked = (error: unknown) => {
  const { data, status } = (error ?? {}) as { data?: any; status?: number };
  if (status !== 404 || !data || typeof data !== 'object') {
    return false;
  }
  const mainNoRoute =
    data.error === 'Not Found' &&
    typeof data.message === 'string' &&
    /^Route GET:\S*\/support\/pos\/\S* not found$/.test(data.message);
  return mainNoRoute || data.error?.code === 'not_found';
};
